import { useMediaThematicContentBlocksQuery } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

const useThematicBlocks = (forDate: string) => {
  const {
    data: thematicContentBlocks,
    loading,
    error,
  } = useMediaThematicContentBlocksQuery({
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
    variables: {
      forDate,
    },
  });

  return {
    error,
    loading,
    items: thematicContentBlocks?.result || [],
  };
};

export default useThematicBlocks;
